import React from 'react';
import PropTypes from 'prop-types';
import { Bert } from 'meteor/themeteorchef:bert';
import { isEmpty } from 'lodash';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import uuid from 'uuid/v1';
import {
  Box,
  Button,
  ButtonGroup,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Tooltip
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Annotations from '../../../api/Annotations/Annotations';
import { LIBRARY_ICON_TYPES } from '../../../api/AnnotationTemplates/AnnotationTemplates';
import useTimeStore from '../ZustandProvider';
import Loading from '../Loading';

const CreateRouteLocation = ({
  annotationList,
  coordinates,
  createRouteConfiguration,
  isLoaded
}) => {
  const setDrawRoute = useTimeStore(state => state.setDrawRoute);
  const [typeRouteSelect, setTypeRouteSelect] = React.useState(createRouteConfiguration.mode);
  const typeRouteOptions = [
    { value: 'foot-walking', name: 'Walking' },
    { value: 'driving-car', name: 'By car' }
  ];
  const [endPointSelected, setEndPointSelected] = React.useState(
    createRouteConfiguration.endPoints.filter(
      index => index.videoId === createRouteConfiguration.endPointDefault
    )
  );

  const renderButtons = buttonConfig => {
    if (!isEmpty(buttonConfig.libraryIcon)) {
      if (buttonConfig.libraryIcon === LIBRARY_ICON_TYPES.FONTAWESOME) {
        return <FontAwesomeIcon icon={buttonConfig.iconFontawesome} size="lg" />;
      }
      if (buttonConfig.libraryIcon === LIBRARY_ICON_TYPES.SVG) {
        return (
          <img
            src={buttonConfig.iconSvg}
            alt={buttonConfig.iconFontawesome}
            style={{ marginRight: '5px', width: '20px', height: '20px' }}
          />
        );
      }
    }

    return '';
  };

  const createRoute = async () => {
    if (!isEmpty(endPointSelected)) {
      const coordsAvoidPoints = annotationList
        .filter(obj => obj.geoJSON.properties.video === createRouteConfiguration.avoidPointsMap)
        .map(obj => obj.geoJSON.geometry.coordinates);

      const coordsEndPoints = endPointSelected.flatMap(item =>
        annotationList
          .filter(obj => obj.geoJSON.properties.video === item.videoId)
          .map(obj => obj.geoJSON.geometry.coordinates)
      );

      try {
        const response = await fetch(
          'https://sd1.ipsgeoprocesing.ipsilum.com/MG/utilities/routing',
          {
            method: 'POST',
            body: JSON.stringify({
              start_point: [coordinates[1], coordinates[0]],
              final_points: coordsEndPoints || [],
              avoid_points: coordsAvoidPoints || [],
              intermediate_points: [],
              type_moving: typeRouteSelect
            }),
            headers: { 'Content-Type': 'application/json' },
            mode: 'cors',
            credentials: 'omit',
            referrerPolicy: 'no-referrer'
          }
        );
        const respuesta = await response.json();
        if (respuesta && respuesta.data) {
          setDrawRoute({
            data: respuesta.data,
            centerOnRoute: createRouteConfiguration.centerOnRoute || false
          });
        } else {
          Bert.alert('No se encontró una posible ruta', 'info');
        }
      } catch (error) {
        Bert.alert('Error al obtener la dirección', 'error');
      }
    } else {
      Bert.alert('Selecciona a qué servicio quieres ir', 'info');
    }
  };

  const handleButtonClick = item => {
    const isSelected = endPointSelected.some(
      selectedItem => JSON.stringify(selectedItem) === JSON.stringify(item)
    );
    if (isSelected) {
      setEndPointSelected(
        endPointSelected.filter(
          selectedItem => JSON.stringify(selectedItem) !== JSON.stringify(item)
        )
      );
    } else {
      setEndPointSelected([...endPointSelected, item]);
    }
  };
  const isItemSelected = item =>
    endPointSelected.some(selectedItem => JSON.stringify(selectedItem) === JSON.stringify(item));

  if (!isLoaded) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Loading />
      </Box>
    );
  }

  return (
    <Box>
      <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
        {createRouteConfiguration.showMode && createRouteConfiguration.showMode === true && (
          <FormControl sx={{ mb: 2, minWidth: 120 }}>
            <InputLabel id="demo-simple-select-label">Saving system</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={typeRouteSelect}
              label="Saving system"
              onChange={event => {
                setTypeRouteSelect(event.target.value);
              }}
              size="small"
            >
              {typeRouteOptions.map(item => (
                <MenuItem key={item.name} value={item.value}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <ButtonGroup variant="contained" aria-label="Basic button group">
          {createRouteConfiguration.endPoints.map(item => (
            <Tooltip title={item.name} key={uuid()}>
              <Button
                key={uuid()}
                onClick={() => handleButtonClick(item)}
                style={{
                  backgroundColor: isItemSelected(item) ? '#2A3F90' : 'white',
                  color: isItemSelected(item) ? 'white' : '#2A3F90',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {item.button.libraryIcon === LIBRARY_ICON_TYPES.FONTAWESOME && (
                  <FontAwesomeIcon
                    icon={item.button.iconFontawesome}
                    size="lg"
                    style={{ marginRight: '5px' }}
                  />
                )}
                {item.button.libraryIcon === LIBRARY_ICON_TYPES.SVG && (
                  <img
                    src={item.button.iconSvg}
                    alt={item.button.altText || 'icon'}
                    style={{ marginRight: '5px', width: '20px', height: '20px' }}
                  />
                )}
              </Button>
            </Tooltip>
          ))}
        </ButtonGroup>
        <Button
          onClick={() => {
            createRoute();
          }}
          sx={{
            color: '#2A3F90',
            backgroundColor: 'white',
            borderColor: '#2A3F90'
          }}
        >
          {renderButtons(createRouteConfiguration.buttonCreateRoute)}
          {createRouteConfiguration.buttonCreateRoute.name}
        </Button>
        <Button
          onClick={() => {
            setDrawRoute([]);
          }}
          sx={{
            color: '#2A3F90',
            backgroundColor: 'white',
            borderColor: '#2A3F90'
          }}
        >
          <DeleteIcon />
        </Button>
      </Stack>
    </Box>
  );
};
export default withTracker(({ createRouteConfiguration }) => {
  const { avoidPointsMap, endPoints } = createRouteConfiguration;
  const videoList = endPoints.map(point => point.videoId);

  if (typeof avoidPointsMap === 'string' && avoidPointsMap.trim() !== '') {
    videoList.push(avoidPointsMap);
  }

  const annotationSub = Meteor.subscribe('manyAnnotations.public', videoList);
  const annotationList = Annotations.find(
    { 'geoJSON.properties.video': { $in: videoList } },
    { sort: { 'geoJSON.properties.video': 1 } }
  ).fetch();

  const isLoaded = annotationSub.ready() && annotationList.length > 0;

  return {
    annotationList,
    isLoaded
  };
})(CreateRouteLocation);

CreateRouteLocation.defaultProps = {
  annotationList: [],
  coordinates: []
};
CreateRouteLocation.propTypes = {
  annotationList: PropTypes.array,
  createRouteConfiguration: PropTypes.object.isRequired,
  coordinates: PropTypes.array,
  isLoaded: PropTypes.bool.isRequired
};
